
const getPersistedStateKey = (
  storeId: string,
  {
    paths,
    key,
    appendPathsToKey,
  }: {
    paths?: string[]
    key?: string
    appendPathsToKey?: boolean
  } = {}
) => {
  if (key) {
    return key
  }

  let uniqueKey = `${storeId}State`

  if (paths && appendPathsToKey) {
    uniqueKey += '_' + paths.join(',')
  }

  return uniqueKey
}

export {
  getPersistedStateKey,
}